/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PaymentDetailsSourceOfMoneyViewModel } from './PaymentDetailsSourceOfMoneyViewModel';
import {
    PaymentDetailsSourceOfMoneyViewModelFromJSON,
    PaymentDetailsSourceOfMoneyViewModelFromJSONTyped,
    PaymentDetailsSourceOfMoneyViewModelToJSON,
} from './PaymentDetailsSourceOfMoneyViewModel';

/**
 * 
 * @export
 * @interface PaymentDetailsEFTPayerViewModel
 */
export interface PaymentDetailsEFTPayerViewModel {
    /**
     * 
     * @type {number}
     * @memberof PaymentDetailsEFTPayerViewModel
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof PaymentDetailsEFTPayerViewModel
     */
    payerPartyId?: number;
    /**
     * 
     * @type {number}
     * @memberof PaymentDetailsEFTPayerViewModel
     */
    amount?: number;
    /**
     * 
     * @type {Array<PaymentDetailsSourceOfMoneyViewModel>}
     * @memberof PaymentDetailsEFTPayerViewModel
     */
    sourcesOfMoney: Array<PaymentDetailsSourceOfMoneyViewModel>;
}

/**
 * Check if a given object implements the PaymentDetailsEFTPayerViewModel interface.
 */
export function instanceOfPaymentDetailsEFTPayerViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "sourcesOfMoney" in value;

    return isInstance;
}

export function PaymentDetailsEFTPayerViewModelFromJSON(json: any): PaymentDetailsEFTPayerViewModel {
    return PaymentDetailsEFTPayerViewModelFromJSONTyped(json, false);
}

export function PaymentDetailsEFTPayerViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaymentDetailsEFTPayerViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'Id') ? undefined : json['Id'],
        'payerPartyId': !exists(json, 'PayerPartyId') ? undefined : json['PayerPartyId'],
        'amount': !exists(json, 'Amount') ? undefined : json['Amount'],
        'sourcesOfMoney': ((json['SourcesOfMoney'] as Array<any>).map(PaymentDetailsSourceOfMoneyViewModelFromJSON)),
    };
}

export function PaymentDetailsEFTPayerViewModelToJSON(value?: PaymentDetailsEFTPayerViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'Id': value.id,
        'PayerPartyId': value.payerPartyId,
        'Amount': value.amount,
        'SourcesOfMoney': ((value.sourcesOfMoney as Array<any>).map(PaymentDetailsSourceOfMoneyViewModelToJSON)),
    };
}

